import Chart from "./Chart";
import CONFIG from "../../../config";
export const config = {
  name: "stackLineChart",
  archive: "图表",
  domain: "折线图",
  alias: "堆叠折线图",
  thumb: CONFIG.ASSET_BASE_URL + "/charts/stackLineChart.png"
}
export const option = () => ({
    dataset: {
        source: [
            ['系列', '系列1', '系列2'],
            ['名称2', 43.3, 85.8],
            ['名称3', 83.1, 73.4],
            ['名称4', 86.4, 65.2],
            ['名称5', 72.4, 53.9]
        ]
    },
    title: {
        text: "堆叠折线图",
      },
      tooltip: {
        axisPointer: {
          type: "none"
        }
      },
      xAxis: {
        type: 'category',
      },
      yAxis: {
        type: 'value', 
      },
      series: [
        {
          type: 'line',
          stack: "堆叠",
          areaStyle: {}
        },
      ],
})
export default (props) => {
  return <Chart defaultOption={option()} {...props}/>
 }